export default "__VITE_ASSET__2_V0ZC$X__"